import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/img/core12-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "ion-padding-horizontal"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "CORE12"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Исполнитель")
], -1)
const _hoisted_4 = { class: "login-footer-link" }
const _hoisted_5 = ["href"]

import { } from 'vue';
import LoginForm from '@/components/user/LoginForm.vue';
import { useNavManager } from '@/composables/useNavManager';
import { useStore } from '@/composables/useApp';
import { useMetrica } from '@/composables/useMetrica';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const contractOfferLink = config.privacyPolicyLink;

const store = useStore();
const navManager = useNavManager();
const { emitEvent } = useMetrica();

const isAuth = store.user.isAuth;

if (isAuth) {
  navManager.navigate({
    routerDirection: 'root',
    routerLink: {
      name: 'doer_provided_services',
    }
  });
}

function toHome() {
  navManager.navigate({
    routerDirection: 'root',
    routerLink: { name: 'doer_provided_services' },
  });
}

function loginned() {
  emitEvent('user/login');
  toHome();
}

return (_ctx: any,_cache: any) => {
  const _component_app_header_big = _resolveComponent("app-header-big")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_app_header_big, { class: "login-header" }),
      _createVNode(_component_ion_content, {
        class: "content-beetween",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (!_unref(isAuth))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(LoginForm, { onSuccess: loginned })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: _unref(contractOfferLink),
              target: "_blank",
              class: "cd-contract-offer-link"
            }, " Посмотреть политику ", 8, _hoisted_5)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})